import React from "react";
import Preloader from "../../helper/Preloader";
import ColorInit from "../../helper/ColorInit";
import LoginForm from "../../components/auth/LoginForm";

const LoginPage = () => {



  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* Preloader */}
      <Preloader />

      <LoginForm />
    </>
  );
};

export default LoginPage;
